const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

/**
 * 时空智友历史数据（按 TAPD 分阶段接入）
 */
export default [
  {
    path: 'historical-data/todo-manage',
    name: 'HistoricalDataTodoManage',
    meta: {
      title: '待办业务管理',
      auth: true
    },
    component: _import('data-center/historical-data-todo-manage/index.vue')
  },
  {
    path: 'historical-data/first-operation-manage',
    name: 'HistoricalDataFirstOperationManage',
    meta: {
      title: '首营管理',
      auth: true
    },
    component: _import('data-center/historical-data-first-operation-manage/index.vue')
  },
  {
    path: 'historical-data/base-data-query',
    name: 'HistoricalDataBaseDataQuery',
    meta: {
      title: '基础资料查询',
      auth: true
    },
    component: _import('data-center/historical-data-base-data-query/index.vue')
  },
  {
    path: 'historical-data/quality-control-query',
    name: 'HistoricalDataQualityControlQuery',
    meta: {
      title: '质量管控查询',
      auth: true
    },
    component: _import('data-center/historical-data-quality-control-query/index.vue')
  }
]
